var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup130(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.625 13.0447H15.9251V14.4282H0.625V13.0447Z",
    fill: "#F3CE7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.625 2.58691H15.9251V3.97043H0.625V2.58691Z",
    fill: "#F3CE7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.17886 2.60317V2.60521H7.37134V2.60317V0.875H9.17886V2.60317Z",
    fill: "#E1B7A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8886 14.4282H10.3691L12.8058 20.1251H14.3252L11.8886 14.4282Z",
    fill: "#E1B7A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.6622 14.4282L2.22559 20.1251H3.74501L6.18163 14.4282H4.6622Z",
    fill: "#E1B7A3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.0084 18.2682L11.982 18.2796H4.56795L4.5415 18.2682L4.99318 17.2151L5.01556 17.2249H11.5344L11.5567 17.2151L12.0084 18.2682Z",
    fill: "#C79A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.3839 3.95658V13.063H1.16626V3.94397H15.3839V3.95658Z",
    fill: "#D4E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.52148 7.66235H7.49808V10.5653H6.52148V7.66235Z",
    fill: "#EB7288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.64966 6.44165H5.62626V10.5653H4.64966V6.44165Z",
    fill: "#EB7288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M2.77783 8.4762H3.75443V10.5653H2.77783V8.4762Z",
    fill: "#EB7288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M0.625 13.0447H1.84575V14.4282H0.625V13.0447Z",
    fill: "#DDBD8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M0.625 2.58691H1.84575V3.97043H0.625V2.58691Z",
    fill: "#DDBD8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.38701 3.94397H1.16626V3.95658V13.063H2.38701V3.95658V3.94397Z",
    fill: "#BCCEE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.84473 10.3184H13.8091V10.8067H8.84473V10.3184Z",
    fill: "#9DB2C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M8.84473 8.69067H13.8091V9.17897H8.84473V8.69067Z",
    fill: "#9DB2C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M8.84473 7.06299H10.8793V7.55129H8.84473V7.06299Z",
    fill: "#9DB2C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M2.04932 4.8656H2.65969V5.3539H2.04932V4.8656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M3.14795 4.8656H7.01366V5.3539H3.14795V4.8656Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup130);
export default __webpack_public_path__ + "static/media/Group 130.fdb9aebd7710b8ec2aef4d39ac4685bf.svg";
export { ForwardRef as ReactComponent };